export default __webpack_public_path__ + "images/ug-83f4207b3f42150d667b04e7fe6b6a47.svg";